"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const systems_1 = require("@/services/systems");
const users_1 = require("@/services/users");
const evaluators_1 = require("@/store/ducks/evaluators");
const buildUsers_1 = require("@/useCases/useCaseUtilities/buildUsers");
function removeEvaluatorUseCase(userId, systemId) {
    return async (dispatch) => {
        try {
            dispatch((0, evaluators_1.deleteEvaluator)());
            const payload = {
                systemIds: [systemId],
                operation: "remove",
            };
            await (0, users_1.associateUserToSystem)(userId, payload);
            const systems = await (0, systems_1.getSystem)(systemId);
            const updatedEvaluators = (0, buildUsers_1.buildUsers)(systems.users, true);
            dispatch((0, evaluators_1.deleteEvaluatorSuccess)({ updatedEvaluators, systemId }));
            dispatch((0, evaluators_1.closeDeleteEvaluatorModal)());
            dispatch((0, evaluators_1.openEvaluatorToast)({ status: "success", message: "Evaluator deleted" }));
        }
        catch (e) {
            dispatch((0, evaluators_1.deleteEvaluatorError)());
            dispatch((0, evaluators_1.openEvaluatorToast)({
                status: "error",
                message: "Error deleting evaluator",
            }));
        }
    };
}
exports.default = removeEvaluatorUseCase;
